/* eslint-disable camelcase */
import React from 'react';
import { Stack } from '@mui/material';
import WholeMeProfileExperiences from 'pages/wholeme/molecules/wholeMeProfileExperiences/WholeMeProfileExperiences';
import WholeMeProfileDocumentSection from '../../../molecules/wholeMeProfileStory/WholeMeProfileDocumentSection';
import WholeMeScrollStorySection from '../../../molecules/wholeMeProfileStory/WholeMeScrollStorySection';

const WholeMeProfileStory = ({
  profile,
  onEdit,
  onStoryChange,
  editable,
}) => {
  const {
    story_documents, story_career, story_life, story_academic,
  } = profile;

  const renderDocumentView = () => (
    <WholeMeProfileDocumentSection
      documents={story_documents}
      editable={editable}
      onDocumentDelete={onStoryChange}
      onDocumentPost={onStoryChange}
      profile={profile}
    />
  );

  const renderScrollStorySection = (dataKey, headerLabel) => (
    <WholeMeScrollStorySection
      profile={profile}
      dataKey={dataKey}
      headerLabel={headerLabel}
      editable={editable}
      onStoryChange={onStoryChange}
    />
  );

  const renderSections = () => (
    <>
      {!story_documents.length && !editable ? null : renderDocumentView()}
      {!story_career.length && !editable ? null : renderScrollStorySection('story_career', 'Career')}
      {!story_academic.length && !editable ? null : renderScrollStorySection('story_academic', 'Academic')}
      {!story_life.length && !editable ? null : renderScrollStorySection('story_life', 'Life')}
    </>
  );

  const renderExperiencesSection = () => (
    <Stack sx={{ py: '20px' }}>
      <WholeMeProfileExperiences
        profile={profile}
        onEdit={onEdit}
      />
    </Stack>
  );

  return (
    <Stack spacing={1.5} sx={{ pt: '10px' }}>
      {renderSections()}
      {renderExperiencesSection()}
    </Stack>
  );
};

export default WholeMeProfileStory;
